import { API_BASE_URL_ENV } from "../jsx/common/common";
import BaseService from "./BaseService";
import http from "./HttpService";

const apiEndpoint = API_BASE_URL_ENV() + "/notification";

export default class NotificationService extends BaseService {
	constructor() {
		super(apiEndpoint);
	}

	create(type, data) {
		if (!type) {
			return http.post(apiEndpoint, { ...data });
		}
		return http.post(`${apiEndpoint}/${type}`, { ...data });
	}

	send(id) {
		return http.post(`${apiEndpoint}/send/${id}`);
	}
}
